import React from "react";
import { useLocalStorage } from '@mantine/hooks';

import { utils } from "../utils/globalVariables";

const NavBarStateContext = React.createContext({})

export const NavBarStateContextProvider = ({ children }) => {

    const [navBarState, setNavBarState] = useLocalStorage({
        key: utils.localStorageName.navBarState,
        defaultValue: true,
        getInitialValueInEffect: false
    });

    const handleSetNavBarStateContext = (param) => {
        setNavBarState(param);
    }

    return (
        <NavBarStateContext.Provider value={{ navBarState, handleSetNavBarStateContext }}>
            {children}
        </NavBarStateContext.Provider>
    )
};

export const useNavBarStateContext = () => React.useContext(NavBarStateContext);